var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-filetypes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "255px",
    height: "142px",
    viewBox: "0 0 255 142",
    enableBackground: "new 0 0 255 142",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-image",
    fill: "#FF10D2",
    d: "M169.656,48.813H145.25c-2.451,0-4.438-1.987-4.438-4.438V19.969 c0-1.226-0.993-2.219-2.219-2.219H92c-2.451,0-4.438,1.987-4.438,4.438v97.625c0,2.451,1.987,4.438,4.438,4.438h75.438 c2.451,0,4.438-1.986,4.438-4.438V51.031C171.875,49.806,170.882,48.813,169.656,48.813z M131.938,110.938l-12.394-12.395 c-1.733-1.732-4.542-1.732-6.275,0l-11.094,11.094c-0.833-0.83-1.301-1.959-1.3-3.137V71c0-2.451,1.987-4.438,4.438-4.438h48.813 c2.451,0,4.438,1.987,4.438,4.438v18.96l-10.181-11.106c-1.656-1.807-4.463-1.928-6.27-0.271c-0.048,0.043-0.095,0.088-0.14,0.133 l-14.854,14.854l17.369,17.369H131.938z M149.688,37.719V17.75l22.188,22.188h-19.969C150.681,39.938,149.688,38.944,149.688,37.719 z M123.063,82.094c0,3.676-2.98,6.656-6.656,6.656s-6.656-2.98-6.656-6.656s2.98-6.656,6.656-6.656S123.063,78.418,123.063,82.094z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.31f59ec54da8d1ea98a6b0ab966b8ad0.svg";
export { ForwardRef as ReactComponent };